var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"container px-4 mx-auto"},[_c('h1',{staticClass:"text-2xl text-red uppercase mb-6"},[_vm._v(_vm._s(_vm.msg))])])])}
var staticRenderFns = []

export { render, staticRenderFns }